import React from 'react'
import { AddButton } from '@e3dc-react/shell/Elements/Buttons'
import useModals from '../../Hooks/useModals'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
interface AddCallButtonProps {
  sapCustomerId?: string
  className?: string
  disabled?: boolean
}

const AddCallButton: React.VFC<AddCallButtonProps> = ({ sapCustomerId, className, disabled }) => {
  const { openCallEditor } = useModals()
  const { t } = useCustomTranslation()

  return (
    <AddButton
      onClick={() => openCallEditor({ sapCustomerId: sapCustomerId })}
      label={t('calls.addCallButton')}
      className={className}
      disabled={disabled}
    />
  )
}

export default AddCallButton
